<template>
  <div class="myResearchItem" @click="$emit('click')">
    <div class="thumb">
      <div class="badge" :class="badgeClass">
        <div class="txt">
          {{detail.statusName}}
        </div>
      </div>
      <van-image class="img" :src="detail.defaultImage" fit="cover" />
    </div>
    <div class="content">
      <div>
        <div class="title omit">{{detail.activityTitle}}</div>
      </div>
      <div class="date">投稿名称：{{detail.title }}</div>
      <div>
        <div class="date">投稿时间：{{detail.createTime | formatDate('yyyy-MM-dd hh:mm:ss', '-')}}</div>
        <div class="date">活动时间：{{detail.startDate | formatDate('yyyy-MM-dd')}} — {{detail.endDate | formatDate('yyyy-MM-dd')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myResearchItem',
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    badgeClass: {
      type: [Object, Array], // 可选值bg-1黄， bg-2红，bg-3绿，bg-4灰
      default: () => {}
    }
  },
  data () {
    return {};
  }
};
</script>

<style lang="less" scoped>
.myResearchItem {
  padding: 30px 28px;
  display: flex;
  .thumb {
    position: relative;
    width: 216px;
    height: 144px;
    .badge {
      position: absolute;
      top: -10px;
      left: 0;
      z-index: 2;
      .txt{
        min-width: 110px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 24px;
        color: #FFFFFF;
        padding-left: 20px;
        padding-right: 20px;
        border-radius: 12px 0 12px 0;
        position: relative;
        z-index: 1;
      }
      &:after{
        content: '';
        width: 0;
        height: 0;
        border: 6px solid transparent;
        border-top-width: 0;
        border-bottom-width: 10px;
        overflow: hidden;
        position: absolute;
        left: 100%;
        top: 0;
        transform: translateX(-6px);
        z-index: -1;
      }
      &.bg-1{
        .txt {
          background-image: linear-gradient(270deg, #FFA41F 0%, #FF8630 100%);
          background-color: #FFA41F;
        }
        &:after{
          border-bottom-color: #D88715;
        }
      }
      &.bg-2{
        .txt {
          background: linear-gradient(270deg, #FF6431 0%, #FF8246 100%);
          background-color: #FF6431;
        }
        &:after{
          border-left-color: #D95423;
          border-bottom-color: #D95423;
        }
      }
      &.bg-3{
        .txt {
          background-image: linear-gradient(270deg, #49D66D 0%, #4BBA7C 100%);
          background-color: #49D66D;
        }
        &:after{
          border-left-color: #4BBB7B;
          border-bottom-color: #4BBB7B;
        }
      }
      &.bg-4{
        .txt {
          background-image: linear-gradient(270deg, #C3C0C0 0%, #B2B1B1 100%);
          background-color: #C3C0C0;
        }
        &:after{
          border-left-color: #A29F9F;
          border-bottom-color: #A29F9F;
        }
      }
    }
    .img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;
    }
  }
  .content {
    width: 0;
    flex: 1;
    margin-left: 28px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-size: 26px;
      font-weight: bold;
      color: #333444;
      line-height: 36px;
      margin-bottom: 8px;
    }
    .date {
      line-height: 36px;
      font-size: 24px;
      font-weight: 500;
      color: #999AAA;
    }
  }
}
</style>